import { render } from "./CatInput.vue?vue&type=template&id=408ffc7c&scoped=true"
import script from "./CatInput.vue?vue&type=script&lang=js"
export * from "./CatInput.vue?vue&type=script&lang=js"

import "./CatInput.vue?vue&type=style&index=0&id=408ffc7c&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/fife-cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408ffc7c"]])

export default __exports__